const get = require('lodash/get')
const isNull = require('lodash/isNull')

const nullThenDefault = (obj, def) => {
    return isNull(obj) ? def : obj
}

const parseHealthpointService = healthPointInfo => {
    const normalizedHealthPoint = {
        id: healthPointInfo.id,
        title: healthPointInfo?.name ?? '',
        slug: healthPointInfo.name ? healthPointInfo.name.toLowerCase().replace(/ /g, '-') : '',
        categories: [],
        procedures: [],
        people: [],
        serviceLocation: {},
        comment: healthPointInfo.comment,
        updatedAt: healthPointInfo.meta ? healthPointInfo.meta.lastUpdated : null
    }

    nullThenDefault(get(healthPointInfo, 'extension[0].extension', []), []).forEach(extension => {
        if (extension.url === 'specialty') {
            normalizedHealthPoint.categories.push({ name: extension.valueString })
        } else if (extension.url === 'healthpoint-service-type') {
            normalizedHealthPoint.type = extension.valueString
        } else if (extension.url === 'website') {
            normalizedHealthPoint.website = extension.valueString
        } else if (extension.url === 'referral-expectations') {
            normalizedHealthPoint.expectations = extension.valueString
        } else if (extension.url === 'last-updated') {
            normalizedHealthPoint.lastUpdated = extension.valueString
        } else if (extension.url === 'dbh-region') {
            normalizedHealthPoint.dbhRegion = extension.valueString
        } else if (extension.url === 'procedure') {
            const procedure = {}
            nullThenDefault(get(extension, 'extension', []), []).forEach(proc => (procedure[proc.url] = proc.valueString))
            normalizedHealthPoint.procedures.push(procedure)
        } else if (extension.url === 'DBH') {
            normalizedHealthPoint.dbh = extension.valueString
        } else if (extension.url === 'additional-contact-details') {
            normalizedHealthPoint.contact = extension.valueString
        } else if (extension.url === 'branch') {
            normalizedHealthPoint.branch = extension.valueString
        } else if (extension.url === 'hp-services-url') {
            normalizedHealthPoint.servicesUrl = extension.valueString
        } else if (extension.url === 'service-location') {
            let location = {}
            nullThenDefault(get(extension, 'extension', []), []).forEach(loc => {
                if (loc.url === 'location') {
                    location.name = loc.valueReference ? loc.valueReference.display : null
                } else if (loc.url === 'street-address') {
                    const { use, type, line = [], city, district, postalCode, country } = loc.valueAddress
                    location = {
                        ...location,
                        use,
                        type,
                        address: line.join('\n'),
                        city,
                        district,
                        postalCode,
                        country,
                    }
                } else if (loc.url === 'postal-address') {
                    const { use, type, line = [] } = loc.valueAddress
                    location.postal = {
                        use,
                        type,
                        address: line.join('\n'),
                    }
                } else if (loc.url === 'email' || loc.url === 'phone' || loc.url === 'mobile' || loc.url === 'fax') {
                    location[loc.url] = loc.valueContactPoint ? loc.valueContactPoint.value : null
                } else if (loc.url === 'subregion') {
                    location.subregion = loc.valueString
                } else if (loc.url === 'hp-location-url') {
                    location.locationUrl = loc.valueString
                }
            })
            normalizedHealthPoint.serviceLocation = location
        } else if (extension.url === 'people-list') {
            const person = {}
            nullThenDefault(get(extension, 'extension', []), []).forEach(per => {
                if (per.url === 'person') {
                    person.display = per.valueReference ? per.valueReference.display : null
                    person.subType = per.valueReference ? per.valueReference.type : null
                } else if (per.url === 'person-type') {
                    person.type = per.valueString
                } else if (per.url === 'person-title') {
                    person.title = per.valueString
                } else if (per.url === 'person-page') {
                    person.page = per.valueString
                } else if (per.url === 'person-photo') {
                    person.photo = per.valueAttachment ? per.valueAttachment.url : null
                }
            })
            normalizedHealthPoint.people.push(person)
        }
    })

    normalizedHealthPoint.location = healthPointInfo.location ? healthPointInfo.location[0].display : ''

    const telecom = {}
    nullThenDefault(get(healthPointInfo, 'telecom', []), []).forEach(tel => {
        telecom[tel.system ? tel.system : 'other'] = tel.value
    })

    normalizedHealthPoint.telecom = telecom

    return normalizedHealthPoint
}

module.exports = parseHealthpointService
